import { render, staticRenderFns } from "./wechatBasicInfoIndex.vue?vue&type=template&id=7a02849e&scoped=true"
import script from "./wechatBasicInfoIndex.vue?vue&type=script&lang=js"
export * from "./wechatBasicInfoIndex.vue?vue&type=script&lang=js"
import style0 from "./wechatBasicInfoIndex.vue?vue&type=style&index=0&id=7a02849e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a02849e",
  null
  
)

export default component.exports